import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Legal from './pages/Legal';
import Outpost from './pages/Outpost';
import BrandDevelopment from './pages/BrandDevelopment';
import ContentProduction from './pages/ContentProduction';
import EcommerceOptimization from './pages/EcommerceOptimization';
import DigitalMarketing from './pages/DigitalMarketing';
import SocialMediaMarketing from './pages/SocialMediaMarketing';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import BrandReport from './pages/BrandReport';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <div className="w-full min-h-screen bg-black text-white selection:bg-white/30">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/outpost" element={<Outpost />} />
          <Route path="/brand-development" element={<BrandDevelopment />} />
          <Route path="/content-production" element={<ContentProduction />} />
          <Route path="/ecommerce-optimization" element={<EcommerceOptimization />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/brand-report" element={<BrandReport />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;